import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import coin from "assets/images/singhCoinCurrency.png";

export default function thirdsinghTable(signUp) {
  const Author = ({ name }) => (
    <MDBox sx={{ width: "100px" }}>
      <MDTypography variant="button" fontWeight="medium">
        {name}
      </MDTypography>
    </MDBox>
  );

  const SinghCoin = ({ singhCoin }) => (
    <MDTypography variant="caption" fontWeight="medium">
      {singhCoin}
      <img src={coin} height="40px" />
    </MDTypography>
  );

  return {
    columns: [
      {
        Header: "ACTIONS",
        accessor: "name",
      },

      { Header: "SINGH COINS", accessor: "singhcoin", align: "right" },
    ],

    rows: [
      {
        name: <Author name="Sign Up" />,

        singhcoin: <SinghCoin singhCoin={signUp} />,
      },
    ],
  };
}
